var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseApiServiceFactory from '../base/BaseApiServiceFactory';
import RestService from './RestService';
var BaseRestApiServiceFactory = /** @class */ (function (_super) {
    __extends(BaseRestApiServiceFactory, _super);
    function BaseRestApiServiceFactory(apiUrl) {
        return _super.call(this, apiUrl) || this;
    }
    BaseRestApiServiceFactory.prototype.getRestService = function (modelType, restEndpoint) {
        if (!this.restServices) {
            this.restServices = new Map();
        }
        var cachedRestService = this.restServices.get(modelType);
        if (!cachedRestService) {
            cachedRestService = new RestService(this.apiWrapper, restEndpoint);
            this.restServices.set(modelType, cachedRestService);
        }
        return cachedRestService;
    };
    return BaseRestApiServiceFactory;
}(BaseApiServiceFactory));
export default BaseRestApiServiceFactory;
//# sourceMappingURL=BaseRestApiServiceFactory.js.map